var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.546 18.582C12.8633 18.33 13.008 18.2133 12.98 18.232C13.8947 17.476 14.6133 16.8553 15.136 16.37C15.668 15.8847 16.116 15.376 16.48 14.844C16.844 14.312 17.026 13.794 17.026 13.29C17.026 12.9073 16.9373 12.6087 16.76 12.394C16.5827 12.1793 16.3167 12.072 15.962 12.072C15.6073 12.072 15.3273 12.2073 15.122 12.478C14.926 12.7393 14.828 13.1127 14.828 13.598H12.518C12.5367 12.8047 12.7047 12.142 13.022 11.61C13.3487 11.078 13.7733 10.686 14.296 10.434C14.828 10.182 15.416 10.056 16.06 10.056C17.1707 10.056 18.006 10.3407 18.566 10.91C19.1353 11.4793 19.42 12.2213 19.42 13.136C19.42 14.1347 19.0793 15.0633 18.398 15.922C17.7167 16.7713 16.8487 17.602 15.794 18.414H19.574V20.36H12.546V18.582Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.99085af24e4f4735ad09ff04da1d5101.svg";
export { ForwardRef as ReactComponent };